import React, { useState, useEffect, useContext } from 'react';

import * as net from "../lib/net";
import {withRouter} from "../lib/react/withRouter";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Bo_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.tra = [];
    this.state.aa = [
                {id: '01', text: 'AVD 01'},
                {id: '02', text: 'AVD 02'}
            ];
    //context.posrend = this;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {

  }

  fknGo(url) {
    //alert(row.href);
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
    <h3>BACKOFFICE</h3>

    <div className="web-p01 flex">

    <div className="web-row">
    <div className="web-col flex">
        <div className="web-btn" onClick={() => this.fknGo("/bos/users") } >
            <div>ANVÄNDARE</div>
            <div>Register på användare</div>
        </div>
        <div className="web-btn" onClick={() => this.fknGo("/bos/kids") } >
            <div>KUNDER</div>
            <div>Register på kunder</div>
        </div>
        <div className="web-btn" onClick={() => this.fknGo("/bos/pids") } >
            <div>PROFILER</div>
            <div>Register på profilerr</div>
        </div>
    </div>
     <div className="web-col flex" style={{padding: "0px 10px"}}>
        <div className="web-btn" onClick={() => this.fknGo("/bos/sids") } >
            <div>SYSTEM</div>
            <div>Register på system</div>
        </div>
        <div className="web-btn" onClick={() => this.fknGo("/bos/udids") } >
            <div>ENHETER</div>
            <div>Register på enheter</div>
        </div>
   </div>
     <div className="web-col flex">
        <div className="web-btn" onClick={() => this.fknGo("/bos/ses") } >
            <div>SESSIONER</div>
            <div>Aktiva sessioner</div>
        </div>
   </div>
   </div>

    </div>

    </div>
  );
  }
}
export default withRouter(Bo_Home);
